import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { memberOptions } from '../options/memberOptions';
import { openItemsOf } from '../options/openItemsOf';
import { AdvancedSearchDialog } from './AdvancedSearchDialog';
import type { IPeopleSearchDialogProps } from './IPeopleSearchDialogProps';

/**
 * «Оберіть особу» (прототип lkAdv kind user): усі учасники воркспейсу в порядку членства з пошуком за ім'ям або поштою; колонки Ім'я ·
 * Ел. пошта · Роль · Відкриті елементи (відкриті записи, призначені особі); клік по рядку вибирає особу.
 */
export function PeopleSearchDialog({ members, onPick, onClose }: IPeopleSearchDialogProps) {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');
  const rows = useMemo(() => memberOptions(members, query).map((m) => ({
    key: m.user.id,
    cells: [{ text: m.user.name, strong: true }, { text: m.email ?? '', muted: true }, { text: t(`roles.${m.role}`, { defaultValue: m.role }) },
      { text: String(openItemsOf(m) ?? '—') }],
    onPick: () => onPick(m.user.id),
  })), [members, query, onPick, t]);
  return (
    <AdvancedSearchDialog title={t('fieldControls.choosePerson')} count={t('fieldControls.people', { count: rows.length })} query={query} onQuery={setQuery}
      columns={[t('fieldControls.colName'), t('fieldControls.colEmail'), t('fieldControls.colRole'), t('fieldControls.colOpenItems')]}
      template="minmax(160px,1.2fr) minmax(180px,1.4fr) 120px 120px"
      rows={rows} onClose={onClose} />
  );
}
